import { render } from "./_form-radio-button.vue?vue&type=template&id=bf362694"
import script from "./_form-radio-button.vue?vue&type=script&lang=js"
export * from "./_form-radio-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__